import { apolloClient } from "@/apollo/index";

import resizeMasterTemplateMutation from "@/apollo/mutations/ResizeMasterTemplate.gql";
import campaignEditorQuery from "@/apollo/queries/v2/CampaignEditor.gql";

import type { MasterTemplate } from "hoxton-types";

export async function resizeMasterTemplate({
    width,
    height,
    masterTemplateId,
    campaignId,
    sandboxMode
}: {
    width: number;
    height: number;
    masterTemplateId: string;
    campaignId: string;
    sandboxMode: boolean;
}) {
    const { data, errors } = await apolloClient.mutate<{
        resizeMasterTemplate: MasterTemplate;
    }>({
        mutation: resizeMasterTemplateMutation,
        variables: {
            width,
            height,
            masterTemplateId,
            campaignId
        },
        context: {
            useLocalDevLink: sandboxMode
        },
        refetchQueries: [
            {
                query: campaignEditorQuery,
                variables: {
                    campaignId
                },
                context: {
                    useLocalDevLink: sandboxMode
                }
            }
        ]
    });

    if (errors?.length) {
        throw new Error(errors.map(e => e.message).join(", "));
    }

    if (!data?.resizeMasterTemplate) {
        throw new Error(`Failed to resize master template. Please try again.`);
    }

    return data.resizeMasterTemplate;
}
